module.exports = __webpack_public_path__ + "static/img/flexiquote-logo-dark.962971e2.svg";